<script>
    import { getTraitTicks } from '../../../khan';
    import { state } from '../../../stores';
    import { isTouchDevice } from '../../../ui';
	import OperationText from '../../ops/OperationText.svelte';
    import { dbClick, dbHover, dbUnhover } from '../dashfuncs';

	export let info = 'After gaining a card or taking control of a [[location]] that has one or more of the following traits, you may mark *one* of them as collected. ([[wildcard]] counts as any one trait for this purpose.)';
	export let p;
	export let preview;

	const isSingleChip = (label) => label.split(' ').length < 2;
</script>

<div class="khan-content-wrapper"
	on:mouseenter={e => {dbHover(e, p, preview, 'track')}}
	on:mousemove={e => {dbHover(e, p, preview, 'track')}}
	on:mouseleave={e => {dbUnhover(e, p)}} 
	on:click={e => {if(!preview && !isTouchDevice()) dbClick(p, 'track'); } } 
	on:touchstart={e => {if(!preview && isTouchDevice()) dbClick(p, 'track'); } } 	
>
	<div class="khan-content-bg" />
	<div class="khan-traits-container">
		<div class="khan-info">
			<OperationText text={info} color="black" size={16} />
		</div>
		<div class="khan-trait-grid">
			{#each getTraitTicks(p, $state) as t}
				<div class="khan-trait" style={t.ticked ? 'background-color: green' : ''}>
					{#if t.ticked}
						✅ <OperationText text={t.text} color="white" size={isSingleChip(t.text) ? 22 : 14} />
					{:else}
						<OperationText text={t.text} color="white" size={isSingleChip(t.text) ? 22 : 14} />
					{/if}
				</div>
			{/each}
		</div>
	</div>
</div>

<style lang="scss">
	.khan-content-wrapper {
		width: 100%;
		height: 61.75%;
		position: absolute;
		bottom: 0;
		overflow: hidden;
		box-sizing: border-box;
		border: 0.15em solid black;
		border-top: none;
		border-radius: 0 0 calc(var(--height) / 7.16) calc(var(--height) / 7.16) ;
	}
	.khan-content-bg {
		width: 100%;
		height: 94.5%;
		position: absolute;
		bottom: 5.5%;
		background: linear-gradient(
			135deg,
			rgba(49, 67, 85, 1) 0%,
			rgba(127, 160, 191, 1) 50%,
			rgba(49, 67, 85, 1) 100%
		);
		box-shadow: inset 0 0 calc(var(--height) / 5.347) black;
		z-index: 1;
	}
	.khan-traits-container {
		width: 100%;
		padding: 1.5em;
		flex-direction: column;
		gap: 1em;
		align-items: center;
		justify-content: flex-start;
		color: white;
		z-index: 2;
	}
	.khan-info {
		height: fit-content;
		padding: 1em 5.5em;
		border: calc(var(--height) / 200.5) solid #eee; //2px solid #eee;
		border-radius: calc(var(--height) / 50.125); //8px;
		background-color: rgba(#eee, 0.75);
		box-shadow: 0 0 calc(var(--height) / 40.1) rgba(black, 0.75); //0 0 10px rgba(black, 0.75);
		& :global(.op-text) {
			text-align: center;
		}
	}
	.khan-trait-grid {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: 1fr 1fr 1fr 1fr;
		row-gap: 0.5em;
		column-gap: 1em;
	}
	.khan-trait {
		padding: 0.5em 0.5em;
		width: 16em;
		height: 4.5em;
		align-items: center;
		justify-content: center;
		border: calc(var(--height) / 200.5) solid #eee; //2px solid #eee;
		border-radius: calc(var(--height) / 50.125); //8px;
		background-color: rgba(#245, 0.5);
		box-sizing: border-box;
		box-shadow: inset 0 0 calc(var(--height) / 20.05) rgba(black, 0.25); //inset 0 0 20px rgba(black, 0.25);
		& :global(.op-text) {
			text-align: center;
		}
	}
</style>
